import React from 'react';
import { StarIcon, BadgeCheckIcon, MapPinIcon } from 'lucide-react';
import { reviews, reviewSummary } from '../data/reviews';
function Stars({
  rating,
  size = 'h-4 w-4'
}: {
  rating: number;
  size?: string;
}) {
  return <div className="flex gap-0.5" role="img" aria-label={`${rating} out of 5 stars`} data-id="element-242" data-mp="1kgig67gv61sm">
      {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className={`${size} ${i <= Math.round(rating) ? 'fill-[#f5b301] text-[#f5b301]' : 'fill-stone-line text-stone-line'}`} aria-hidden="true" data-id="element-243" data-mp="1gfowxred9b62" />)}
    </div>;
}
export function ReviewsSection() {
  const {
    average,
    total,
    distribution
  } = reviewSummary;
  const max = Math.max(...distribution.map(d => d.count));
  return <section id="reviews" className="scroll-mt-20 bg-cream py-20 md:py-28" data-id="element-244" data-mp="wsipf7jjybe1">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-245" data-mp="wqefa7v28g5b">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-246" data-mp="nrklep9463vg">
          <h2 className="font-display text-3xl font-bold leading-tight text-forest md:text-5xl" data-id="element-247" data-mp="ns2pu95xjoeg">
            What your neighbors are saying
          </h2>
          <div className="mt-8 flex items-end gap-4" data-id="element-248" data-mp="3qpwj1ojewswr">
            <span className="font-display text-6xl font-bold leading-none text-ink" data-id="element-249" data-mp="3qqo445fdv88s">{average.toFixed(1)}</span>
            <div className="pb-1" data-id="element-250" data-mp="3cvvjiskmz1vc">
              <Stars rating={average} size="h-5 w-5" data-id="element-251" data-mp="3gz1x6la2vvbu" />
              <p className="mt-1 text-sm text-ink-muted" data-id="element-252" data-mp="3gxh0oq47e2bc">{total} Google reviews</p>
            </div>
          </div>
          <dl className="mt-6 space-y-1.5" data-id="element-253" data-mp="8hxdo8u4lg4q">
            {distribution.map(({
            stars,
            count
          }) => <div key={stars} className="flex items-center gap-3 text-sm" data-id="element-254" data-mp="3vopvddmyqdvc">
                <dt className="w-3 text-ink-muted" data-id="element-255" data-mp="3vqsjtt8gvyxy">{stars}</dt>
                <dd className="h-2 flex-1 overflow-hidden rounded-full bg-stone-line" data-id="element-256" data-mp="4gtzrrvn1u65">
                  <span className="block h-full rounded-full bg-[#f5b301]" style={{
                width: `${max ? count / max * 100 : 0}%`
              }} data-id="element-257" data-mp="2k89h3nn5a3a2" />
                </dd>
              </div>)}
          </dl>
        </div>

        <ul className="gap-5 sm:columns-2" data-id="element-258" data-mp="urdrvezpuzc0">
          {reviews.map(r => <li key={r.name} className="mb-5 break-inside-avoid rounded-xl border border-stone-line bg-white p-5" data-id="element-259" data-mp="pu3w7hlqhrfq">
              <div className="flex items-start gap-3" data-id="element-260" data-mp="l11afvn77ma3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white" style={{
              backgroundColor: r.avatarColor
            }} aria-hidden="true" data-id="element-261" data-mp="h10l3fyk9qo9">
                  {r.initials}
                </span>
                <div className="min-w-0" data-id="element-262" data-mp="74xm2iz0a85j">
                  <p className="font-semibold text-ink" data-id="element-263" data-mp="22q51ezbk1wc">{r.name}</p>
                  <p className="text-xs text-ink-muted" data-id="element-264" data-mp="3u7ahrmo3l1vd">{r.meta}</p>
                </div>
              </div>
              <div className="mt-3 flex items-center gap-2" data-id="element-265" data-mp="1wh975gfy83du">
                <Stars rating={r.rating} data-id="element-266" data-mp="1wgpykqc6urch" />
                <span className="text-xs text-ink-muted" data-id="element-267" data-mp="1sg77iyi4dpbc">{r.timeAgo}</span>
              </div>
              <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-268" data-mp="3adslx342p3dl">{r.text}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-ink-muted" data-id="element-269" data-mp="3abpwolaqve9x">
                <span className="inline-flex items-center gap-1" data-id="element-270" data-mp="3k3c5kazm119i">
                  <BadgeCheckIcon className="h-3.5 w-3.5 text-leaf" aria-hidden="true" data-id="element-271" data-mp="3k45gzp9ikexz" />
                  {r.service}
                </span>
                <span className="inline-flex items-center gap-1" data-id="element-272" data-mp="2rey9i0s30f0l">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-273" data-mp="2rgrhbjefl5a6" />
                  {r.city}, TX
                </span>
              </div>
              {r.ownerReply && <div className="mt-4 rounded-lg bg-stone-soft p-3" data-id="element-274" data-mp="30ebhep0k4vj7">
                  <p className="text-xs font-semibold text-ink" data-id="element-275" data-mp="35e7qv3s0xf65">Response from the owner</p>
                  <p className="mt-1 text-sm leading-relaxed text-ink-muted" data-id="element-276" data-mp="fp5m1x55k66n">{r.ownerReply}</p>
                </div>}
            </li>)}
        </ul>
      </div>
    </section>;
}